import 'css-chunk:src/components/widgets/Image/ImageWithTag.scss';export default {
  "imageContainer": "_imageContainer_10wze_1",
  "tagContainer": "_tagContainer_10wze_5"
};